import { Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import HeadingBack from '../../../component/HeadingBack';
import { UserServices } from '../../../redux/Services';
import { GetLoggedInUser } from '../../../utils';
import { usePermission, useRights } from '../../../hooks/usePermission';
import { UserId } from "../../../utils";
import LoadingButton from '../../../component/LoadingButton';
const UserPermission = () => {
    // Viewing needs View; changing needs Edit (checked below)
    const permission = usePermission("Users Management", "List");
    const rights = useRights("Users Management");
    const { roleId } = useParams();
    const user = {
        UserId: UserId
    }
    let LOG_IN_USER = GetLoggedInUser();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [permissionsValue, setPermissionsValue] = useState([]);
    const [columnOptions, setColumnOptions] = useState([]);
    const ModuleData = useSelector(state => state.user.filterData || null);
    const roleData = useSelector(state => state.user.roleDetail || {});
    // Shared roles (and other organizations' roles) are view-only
    const canEdit = !!roleData?.CanEdit && rights.Edit && String(roleData?.RoleId) === String(roleId);
    // Levels the logged-in user may give (never more than their own role has)
    const canGrant = (module, level) =>
        (roleData?.GrantableLevels?.[module] || []).includes(Number(level));
    const { mutate: getFilterData, isLoading } = useMutation((data) => dispatch(UserServices.fetchFilterDataApi(data, user)));
    const { mutate: fetchRoleById } = useMutation((data) => dispatch(UserServices.fetchRolesByIdApi(data, roleId, user)));
    const { mutateAsync: updatePermission } =useMutation((_data) => dispatch(UserServices.updatePermissionApi(_data, roleId,navigate)));

    useEffect(() => {
        fetchRoleById({});
        getFilterData({});
        // getFilterData({});
        // console.log('ModuleData', ModuleData);
        return () => { }
    }, [roleId])

    useEffect(() => {
        if (ModuleData && ModuleData?.FilterData?.ModuleName) {
            var modules = Object.values(ModuleData?.FilterData?.ModuleName);
            setColumnOptions(modules)
        }
        return () => { }
    }, [ModuleData])

    useEffect(() => {
        // A new role has no permissions yet; don't keep the previous role's
        if (String(roleData?.RoleId) === String(roleId)) {
            setPermissionsValue(JSON.parse(roleData?.Permission || "[]"));
        }
    }, [roleData])

    const handleUpdatePermission = () => {
        let payload = {
            UserId: LOG_IN_USER?.UserId,
            Permissions: permissionsValue
        }
        return updatePermission(payload)
    }

    const handleSetPermission = (e) => {
        let moduleName = (e.target.name);
        let value = e.target.value;
        let arr = [...permissionsValue];
        const index = arr.findIndex(object => {
            return object.module === moduleName;
        });
        if (e.target.checked) {
            if (index > -1) {
                arr[index].permission = value;
            } else {
                arr.push({ module: moduleName, permission: value });
            }
        } else {
            if (index > -1) {
                arr[index].permission = "";
            }
        }
        setPermissionsValue(arr);
    }
    const getCheckedPermission = (module, value) => {
        let _obj = permissionsValue && permissionsValue?.length > 0 && permissionsValue?.find(ele => ele?.module == module && ele?.permission == value);
        return _obj ? true : false;
    }
    const columns = [
        {
            title: 'Module Name',
            dataIndex: 'ModuleName',
            key: 'ModuleName',
            width: '250px',
            render: (value, item, index) => {
                return (< span >{item}</span >)
            }

        },
        {
            title: 'View',
            dataIndex: 'View',
            key: 'View',
            render: (value, item, index) => (
                <div>
                    <input className="largeCheckbox" type="checkbox" name={item} checked={getCheckedPermission(item, 1)} value={1} onChange={handleSetPermission} disabled={!canEdit || !canGrant(item, 1)} />
                </div>
            )
        },
        {
            title: 'View | Add',
            dataIndex: 'ViewAdd',
            key: 'ViewAdd',
            render: (value, item, index) => (
                <div>
                    <input className="largeCheckbox" type="checkbox" name={item} checked={getCheckedPermission(item, 2)} value={2} onChange={handleSetPermission} disabled={!canEdit || !canGrant(item, 2)} />
                </div>
            )
        },
        {
            title: 'View | Edit',
            dataIndex: 'ViewEdit',
            key: 'ViewEdit',
            render: (value, item, index) => (
                <div>
                    <input className="largeCheckbox" type="checkbox" name={item} checked={getCheckedPermission(item, 3)} value={3} onChange={handleSetPermission} disabled={!canEdit || !canGrant(item, 3)} />
                </div>
            )
        },
        {
            title: 'View | Edit | Add',
            dataIndex: 'ViewEditAdd',
            key: 'ViewEditAdd',
            render: (value, item, index) => (
                <div>
                    <input className="largeCheckbox" type="checkbox" name={item} checked={getCheckedPermission(item, 4)} value={4} onChange={handleSetPermission} disabled={!canEdit || !canGrant(item, 4)} />
                </div>
            )
        },
        {
            title: 'View | Edit | Add | Delete',
            dataIndex: 'ViewEditAddDelete',
            key: 'ViewEditAddDelete',
            render: (value, item, index) => (
                <div>
                    <input className="largeCheckbox" type="checkbox" name={item} checked={getCheckedPermission(item, 5)} value={5} onChange={handleSetPermission} disabled={!canEdit || !canGrant(item, 5)} />
                </div>
            )
        },
    ];

    return (
        <div>
            <div className='flex'>
                <div>
                    <HeadingBack
                        title={roleData?.Role ? `ROLE: ${roleData.Role}` : "ROLE"}
                        subHeading={roleData?.RoleId && !canEdit ? "View only" : ""}
                    />
                </div>
            </div>
            <div className='mt-10'>
                <div className='permissionBox'>
                    <Table
                        className={isLoading ? 'table antd_table no_data_found_hide' : 'table antd_table'}
                        columns={columns}
                        dataSource={(columnOptions).length > 0 ? columnOptions : []}
                        pagination={false}
                    />
                </div>
                {canEdit && (
                    <div className='text-center mt-20'>
                        <LoadingButton type="button" style={{ maxWidth: "120px" }} className='gradient-button' onClick={handleUpdatePermission}>Update</LoadingButton>
                    </div>
                )}
            </div>
        </div>
    )
}

export default UserPermission